import { jsxs as d, jsx as e } from "react/jsx-runtime";
import { Fragment as n } from "react";
import { GenericLink as c, Carousel as o } from "@nextgen-web-framework/all";
import { s as r, F as f } from "../../FeaturedCard-927918cf.mjs";
const C = (s) => {
  var t;
  const a = s, l = a.featuredCradsList || [];
  return /* @__PURE__ */ d("div", { className: `${r["featured-container"]}`, "data-testid": "featured-cards-test-id", "data-pod-name": "commerce", children: [
    /* @__PURE__ */ d("div", { className: r["featured-header-container"], children: [
      /* @__PURE__ */ e("h2", { className: r["featured-header-title"], children: a.heading }),
      ((t = a.viewAllLink) == null ? void 0 : t.title) && /* @__PURE__ */ e("div", { className: r["featured-header-view-all"], children: /* @__PURE__ */ e(
        c,
        {
          href: a.viewAllLink.href,
          forceNative: !1,
          target: a.viewAllLink.target,
          children: a.viewAllLink.title
        }
      ) })
    ] }),
    /* @__PURE__ */ e("div", { className: r["featured-card-container"], children: /* @__PURE__ */ e(o, { id: "Feature-Card-Carousel", isTileCarousel: !0, children: l.map((i) => /* @__PURE__ */ e(n, { children: /* @__PURE__ */ e(f, { ...i }) }, i.heading)) }) })
  ] });
};
export {
  C as default
};
//# sourceMappingURL=FeaturedCardContainer.js.map
